import React from "react";
import PropTypes from "prop-types";
import { ComponentToString } from "../util";

Link.propTypes = {
  name: PropTypes.string,
  location: PropTypes.string
};

export function Link(props) {
  return (
    <a href={props.location} target="_client_profile">
      {props.name}
    </a>
  );
}

export default function linkToString(instance, td, row, col, prop, value) {
  const rowData = instance.getSourceDataAtRow(row);
  const props = {
    name: value,
    location: `/organizations/${rowData[12]}/client_profiles/${rowData[12]}?client_uid=${rowData[7]}&object_id=${rowData[11]}`
  };

  td.innerHTML = ComponentToString(Link, { ...props });
}
